export default __webpack_public_path__ + "static/sp-textarea-66be2a64168ad653ede7498d9ffebad9.png";